import { useDispatch } from "react-redux";
import { useEffect, useReducer, useRef, useState } from "react";
import { Form, Row, Col, Stack } from "react-bootstrap";
import { TextButton } from 'Components/Button';
import { validateComment } from "../OpenForCommentAxiosFuncs";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from "Utils/constants";
import { textInputDataReducer } from "Components/Forms/FormReducers/TextInputReducer";
import { ACTIONS } from "Components/Forms/FormReducers/TextInputReducer";
import { displayErrors } from "Components/Messages/ErrorMessage";
import ThankYou from "./ThankYou";
import ItemCommentCount from "../ItemComment/ItemCommentCount";
import { config } from "Utils/config";
const GeneralComment = ({setStatusData,setStatusVariant,setShowStatusPopup, generalFeedback, generalFeedbackInputDispatch}) => {

  const dispatch = useDispatch();

  const [showPopup, setShowPopup] = useState(false);

    const handleClear = (e) => {
        generalFeedbackInputDispatch({
            type: ACTIONS.TEXT_AREA_CHANGE,
            value: "",
            maxLength: 2000,
            name: generalFeedback.name
        });
    }

    const handleClose = () => {
        setShowPopup(false);
    }

    const handleInputTextAreaChange = (dispatch, e, pattern) => {
        //console.log("print out the text input change", e, e.target.attributes.id, e.target.value);
        //console.log(e);
        //console.log(e.target.maxLength);
        if (pattern != null) {
            var emptyP = /^$/g;
            if (e.target.value.match(pattern) || e.target.value.match(emptyP)) {
                dispatch({
                    type: ACTIONS.TEXT_AREA_CHANGE,
                    value: e.target.value,
                    maxLength: 2000,
                    name: e.target.name
                });
            }
        }
        else {
            dispatch({
                type: ACTIONS.TEXT_AREA_CHANGE,
                value: e.target.value,
                maxLength: 2000,
                name: e.target.name
            });

        }

    }

    const openSaveCommentPopup = (commentText) => {
        // validate the coment text first
        validateComment(commentText).then((res) => {
            config.isDebugEnabled && console.log("openSaveCommentPopup() validate res", res);
            let statusCode = res?.data?.data?.statusCode;
            //console.log(statusCode);
            if (statusCode === 1) {
                // success
                setShowPopup(true);
                
            } 
            else {

                if (res?.data?.globalErrorMessageList != null && res?.data?.globalErrorMessageList.length > 0) {
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.DATA_ERROR.title,
                            msg: res?.data?.globalErrorMessageList,
                            showContactHelp: true
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    });
                } else {
                    // parse field error messages
                    //let errCodeList = res?.data?.errorCodeList;
                    let errMsgList = res?.data?.data?.errorMessageList;
                    // build json object for the field error display
                    // let msg = {
                    //     comment: { inValid: false, msg: [] }
                    // }
                    // msg.comment.inValid = true;
                    // msg.comment.msg = errMsgList;
                    // setValidationMsg(msg);

                    //console.log(errMsgList);
                    generalFeedbackInputDispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        errors: errMsgList
                    });
                }
            }
        }).catch((error) => {
            //console.log("error getBatchDetailInfo()", error);
            setStatusData({
                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                message: ERROR_MESSAGES.GENERAL_ERROR.message,
                showContactHelp: true
            })
            setStatusVariant("error");
            setShowStatusPopup(true);   
        });
    }

    return (
        <>
            {showPopup == true
                ?   <ThankYou
                        show={showPopup}
                        handleClose={handleClose}
                        comments={generalFeedback.value}
                        submitType={"general"}
                        setStatusData={setStatusData}
                        setStatusVariant={setStatusVariant}
                        setShowStatusPopup={setShowStatusPopup}
                        handleClear={handleClear}
                    >
                    </ThankYou>
                :   null
            }
           
            {/** Save Comments Popup */}
            {/* {showPopup ? <SaveCommentPopup show={showPopup} handleClose={handleClose} commentText={generalFeedback.value} /> : null} */}

            <Row className="m-0 p-0" >
                <Col /*lg={9}*/ className="text-lg-start p-0">
                
                <Form className="d-flex flex-column gap-4">
                    {/*  */}
                    <Form.Group as={Col}  controlId={"ct-feedback-text"} className="d-flex flex-column">
                        <Form.Label
                            //htmlFor={"feedback"}
                            className="header4 bold color-baseblack mb-2">
                            General Feedback on the Common Formats
                        </Form.Label>
                        <div className="textarea-comp-container">
                            <div className="textarea-container">
                                <Form.Control
                                    //id="ct-feedback-text"
                                    name={generalFeedback.name}
                                    as="textarea"
                                    className=""
                                    isInvalid={generalFeedback.validation.isInvalid ? "invalid" : ""}
                                    //isInvalid={validationMsg.comment?.inValid}
                                    onChange={(e)=>handleInputTextAreaChange(generalFeedbackInputDispatch,e,null)}
                                    onInput={(e)=>handleInputTextAreaChange(generalFeedbackInputDispatch,e,null)}
                                    rows={10}
                                    placeholder="Please enter your comment here.. It must be at least 25 characters long."
                                    value={generalFeedback.value}
                                    maxLength={2000}
                                    //minLength={25}
                                    cols={90}
                                >

                                </Form.Control>
                            </div>
                            <Form.Text className="d-flex regular justify-content-end bodyXS lh-sm color-base-darkergray">
                                <ItemCommentCount count={generalFeedback.count}></ItemCommentCount>
                            </Form.Text>
                            <Form.Control.Feedback className={generalFeedback.validation.isInvalid ? "is-invalid bodyS" : "bodyS"} type="invalid">
                                {displayErrors(generalFeedback.name, generalFeedback.validation.errors) }
                                
                            </Form.Control.Feedback>
                        </div>
                        
                    
                    </Form.Group>

                    <Stack className="pt-0 justify-content-start flex-column flex-sm-row" direction="horizontal" gap={4}>
                        {/* Submit Button */}
                        <TextButton
                            variant="comp-primary"
                            onClick={() => openSaveCommentPopup(generalFeedback.value)}
                            content={"Submit Comment"}
                            className="w-xs-100 w-md-fit-content darker-disabled"
                            size="lg"
                            //ref={saveBtnRef}
                            disabled={generalFeedback.count < 25 ? true : false}
                            //disabled={isLoading != true && isLoadingSubmit != true ? false : true}
                        >
                        </TextButton>

                        {/* Clear Button */}
                        <TextButton
                            variant="comp-outline"
                            onClick={handleClear}
                            content={"Clear"}
                            className="w-xs-100 w-md-fit-content"
                            size="lg"
                            //disabled={isLoading != true && isLoadingSubmit != true ? false : true}
                        >
                        </TextButton>
                    </Stack>



                </Form>

                </Col>
            </Row>
        </>
    )
}

export default GeneralComment;